<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<div *ngIf="!loadingLife else loading" class="logs">
    <div *ngFor="let item of taskLifeData; let i = index"
         [attr.data-log-index]="i"
         [class.board_logs]="!!boardLife"
         class="log">
        <div class="log__title">
            <b>
                <span (click)="openTask(item)"
                      *ngIf="boardLife && boardLife.length"
                      class="user_profile"
                >
                    {{ 'TASKS.LOGS.TASK' | translate }} #{{ item.task_alias }}<br>
                </span>
                {{ 'TASKS.LOGS.TITLE.' + item.wrap.title | translate }}
            </b>
            <span>
                {{ 'TASKS.LOGS.AUTHOR' | translate }}:
                <span (click)="helper.openProfileByGuid(item.user.guid)"
                      *ngIf="item.user"
                      [class.blocked_user]="item.user.project_setting.observation_type === 'blocked'"
                      [class.inactive_user]="!item.user.is_active"
                      class="user_profile"
                      data-action="openLogMember"
                >
                    <img *ngIf="item.user.project_setting.is_project_admin"
                         alt="#"
                         ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                         src="../../../../assets/images/admin.svg">
                    {{ helper.shortFullName(item.user, !boardLife) }}
                </span>
                <span *ngIf="!item.user">{{ 'TASKS.LOGS.SYSTEM' | translate }}</span>
            </span>
        </div>

        <div [innerHTML]="'TASKS.LOGS.BODY.' + item.wrap.body.key | translate:item.wrap.body.data"
             class="log__content"></div>
        <small class="log__time">{{ item.created_at | date:'HH:mm dd.MM.yyyy' }}</small>
    </div>
</div>
<i *ngIf="!taskLifeData.length">{{ 'EMPTY_LISTS.LOGS' | translate }}</i>

<app-component-pagination (page)="changePage($event)"
                          *ngIf="!boardLife"
                          [pagination]="pagination"
                          [totalPages]="pagination.pages"
></app-component-pagination>

<ng-template #taskView let-modal>
    <app-button-modal-close [modal]="modal" modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <app-component-task-detail (emitOnDelete)="$event ? modal.close() : null"
                                   [taskAlias]="taskAlias"
        ></app-component-task-detail>
    </div>
</ng-template>